import { createConfigParametersRepository } from '../../configParametersRepository';
import { MKTTRACK_COOKIE_NAME } from '../resources/constants';
import { isGfsBotUserAgent } from './userAgent';

/**
 * Parses the current URL's hostname and applies a regex to match specific domain patterns.
 * The regex matches any string that starts with "edreams", "opodo", "travellink", or "govoyages", followed by a dot and any other characters.
 * If the hostname matches this regex, the function returns the match prefixed with a dot.
 * If there's no match, the function returns the original hostname.
 *
 * @returns {string} The matched domain or the original hostname.
 */
export const parseCookieDomain = (): string => {
  const url = new URL(window.location.href);
  const hostname = url.hostname;

  const regex = /((?:edreams|opodo|travellink|govoyages)\..*)/;
  const match = hostname.match(regex);
  if (match && match[1]) {
    return '.' + match[1];
  }

  return hostname;
};

/**
 * Check if marketing cookie includes specific patterns in order to skip tracking.
 * Also returns `true` when the GFS bot User-Agent is detected (PEX-3808).
 * @returns {boolean}
 */
export const shouldSkipTracking = (): boolean => {
  if (isGfsBotUserAgent()) return true;
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  const cookie = storageClient?.getCookie(MKTTRACK_COOKIE_NAME) || '';
  const re =
    /(\||^)(utmcmd=monitoring|utmcmd=benchmark|utmcct=price_check)(\||$)/g;
  return re.test(cookie);
};
